import React from 'react';
import BaseForm from '../theme/forms/BaseForm';
import BaseModal from '../theme/modals/BaseModal';
import Input from '../theme/forms/Input';
import { connect } from 'react-redux';
import { getActiveCampaigns } from '../../store/api/calls';
import {
  setFocusedCampaign,
  clearSiteCanvassCache,
  clearCampaignCanvassersCache,
  clearCampaignSitesCache,
  clearCampaignOfficeCache,
  clearCampaignAggCache,
} from '../../store/actions';

class CampaignSelectScreen extends React.Component {
  componentDidMount() {
    getActiveCampaigns();
  }

  handleCampaignSelection = (id) => {
    this.props.setFocusedCampaign(id);
    this.props.history.push('/');
  };

  mapPermissionsGroups() {
    let groups = [];

    this.props.permissions_groups.forEach((item) => {
      groups.push(item.id);
    });

    return groups;
  }

  filterOptionsByPermission() {
    if (!this.props.permissions_groups) return [];

    let result = [];
    let admin = this.props.permissions_groups.find((item) => item.name === 'admin');
    let root = this.props.permissions_groups.find((item) => item.name === 'root');

    if (admin || root) return this.props.campaigns;

    let groups = this.mapPermissionsGroups();

    if (!this.props.campaigns) return result;

    this.props.campaigns.forEach((campaign) => {
      if (groups.includes(campaign.auth_group_id)) {
        result.push(campaign);
      }
    });

    return result;
  }

  renderCampaignOptions = () => {
    let campaigns = this.filterOptionsByPermission();
    this.props.clearCampaignAggCache();
    this.props.clearSiteCanvassCache();
    this.props.clearCampaignCanvassersCache();
    this.props.clearCampaignSitesCache();
    this.props.clearCampaignOfficeCache();

    if (campaigns.length === 1) {
      this.handleCampaignSelection(campaigns[0].id);
    }

    let options = campaigns.map((d, i) => {
      return (
        <div
          className="campaign-option card wox-card"
          onClick={() => this.handleCampaignSelection(d.id)}
        >
          <div className="campaign-name no-select">{d.name}</div>
        </div>
      );
    });

    if (!options.length) {
      return (
        <h3 style={{ color: 'white' }}>
          <div
            className="campaign-option card wox-card"
            style={{ width: '100%', height: '25vh' }}
            onClick={() => this.props.history.goBack()}
          >
            <div class="campaign-name" style={{ fontSize: '.7em', padding: '2em' }}>
              You haven't yet been assigned to a campaign in Wox. Please ask your admin to adjust
              your permissions. Click this to log out.
            </div>
          </div>
        </h3>
      );
    } else {
      return options;
    }
  };

  render() {
    return (
      <div className="campaign-select-wrapper metallicFlash">
        <div className="top-logo no-select">
          <img src={"/logo-full192.png"} alt={"ElecTrek"} className={'shadow'} />
        </div>
        <div className="campaign-option-container">{this.renderCampaignOptions()}</div>
        <div className="campaign-option-footer">&nbsp;</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.session.campaigns,
  refreshToken: state.session.refreshToken,
  accessToken: state.session.accessToken,
  permissions_groups: state.permissions.groups,
});

const mapDipatchToProps = (dispatch) => ({
  setFocusedCampaign: (id) => dispatch(setFocusedCampaign(id)),
  clearSiteCanvassCache: () => dispatch(clearSiteCanvassCache()),
  clearCampaignCanvassersCache: () => dispatch(clearCampaignCanvassersCache()),
  clearCampaignSitesCache: () => dispatch(clearCampaignSitesCache()),
  clearCampaignOfficeCache: () => dispatch(clearCampaignOfficeCache()),
  clearCampaignAggCache: () => dispatch(clearCampaignAggCache()),
});

export default connect(mapStateToProps, mapDipatchToProps)(CampaignSelectScreen);
